import { Toaster as Sonner } from "sonner"
import { uiFontSans } from "@/lib/uiTypography"

const Toaster = ({
  theme = "light",
  ...props
}) => {
  return (
    <Sonner
      theme={theme}
      className={`toaster group ${uiFontSans}`}
      toastOptions={{
        classNames: {
          toast:
            `group toast ${uiFontSans} text-sm group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg`,
          title: "text-sm font-semibold",
          description: "text-sm text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground text-sm font-medium",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground text-sm font-medium",
        },
      }}
      {...props} />
  );
}

export { Toaster }
